const PLACEHOLDER = '/assets/attorney-placeholder-f.svg';

let allAttorneys = [];
let filterIndex = { practices: [], industries: [], schools: [], positions: [] };
let activeFilters = { alpha: '', name: '', practice: '', industry: '', school: '', position: '' };

function esc(str) {
	if (!str) return '';
	return String(str)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;');
}

async function init() {
	const res = await fetch('/attorneys.json');
	const json = await res.json();
	allAttorneys = json.data;
	buildFilterIndex(allAttorneys);
	activeFilters = readUrlState();
	render();
	bindEvents();
}

function readUrlState() {
	const p = new URLSearchParams(window.location.search);
	return {
		alpha:    p.get('alpha')    || '',
		name:     p.get('name')     || '',
		practice: p.get('practice') || '',
		industry: p.get('industry') || '',
		school:   p.get('school')   || '',
		position: p.get('position') || '',
	};
}

function buildFilterIndex(attorneys) {
	const practices = new Map(), industries = new Map(), schools = new Map(), positions = new Map();
	attorneys.forEach(a => {
		a.practices.forEach(p => practices.set(p.slug, p));
		a.industries.forEach(i => industries.set(i.slug, i));
		a.schools.forEach(s => schools.set(s.slug, s));
		if (a.position) positions.set(a.position.slug, a.position);
	});
	const byTitle = (a, b) => a.title.localeCompare(b.title);
	filterIndex = {
		practices:  [...practices.values()].sort(byTitle),
		industries: [...industries.values()].sort(byTitle),
		schools:    [...schools.values()].sort(byTitle),
		positions:  [...positions.values()].sort(byTitle),
	};
}

function applyFilters(attorneys, filters) {
	return attorneys.filter(a => {
		if (filters.alpha && (!a.lastName || a.lastName[0].toUpperCase() !== filters.alpha)) return false;
		if (filters.name) {
			const q = filters.name.toLowerCase();
			if (!a.title.toLowerCase().includes(q)) return false;
		}
		if (filters.practice && !a.practices.some(p => p.slug === filters.practice)) return false;
		if (filters.industry && !a.industries.some(i => i.slug === filters.industry)) return false;
		if (filters.school   && !a.schools.some(s => s.slug === filters.school))     return false;
		if (filters.position) {
			const positionSlugs = a.positionSlugs || (a.position ? [a.position.slug] : []);
			if (!positionSlugs.includes(filters.position)) return false;
		}
		return true;
	});
}

function cardTemplate(a) {
	const img = a.headshot
		? `<img src="${esc(a.headshot.url)}" width="${esc(a.headshot.width)}" height="${esc(a.headshot.height)}" alt="${esc(a.headshot.alt)}" loading="lazy">`
		: `<img src="${PLACEHOLDER}" alt="" loading="lazy">`;
	const pos = a.position ? `<p>${esc(a.position.title)}</p>` : '';
	return `<a href="${esc(a.url)}" class="attorneys-home-card">
		<div class="attorneys-home-card-image">${img}</div>
		<div class="attorneys-home-card-content"><h2>${esc(a.title)}</h2>${pos}</div>
	</a>`;
}

function renderGrid(filtered) {
	const grid = document.getElementById('attorneys-grid');
	if (!grid) return;
	if (!filtered.length) {
		grid.innerHTML = `<div class="attorneys-home-empty"><p>We’re sorry there are no attorneys matching your search. <a href="/attorneys">View all</a> or try a different search.</p></div>`;
		return;
	}
	grid.innerHTML = filtered.map(cardTemplate).join('');
}

function renderDropdowns(filtered, filters) {
	const ap = new Map(), ai = new Map(), as_ = new Map(), apos = new Map();
	filtered.forEach(a => {
		a.practices.forEach(p => ap.set(p.slug, p));
		a.industries.forEach(i => ai.set(i.slug, i));
		a.schools.forEach(s => as_.set(s.slug, s));
		if (a.position) apos.set(a.position.slug, a.position);
	});

	const preserve = (map, fullList, slug) => {
		if (slug && !map.has(slug)) {
			const found = fullList.find(o => o.slug === slug);
			if (found) map.set(slug, found);
		}
	};
	preserve(ap,   filterIndex.practices,  filters.practice);
	preserve(ai,   filterIndex.industries, filters.industry);
	preserve(as_,  filterIndex.schools,    filters.school);
	preserve(apos, filterIndex.positions,  filters.position);

	const byTitle = (a, b) => a.title.localeCompare(b.title);
	populateSelect('filter-practice', [...ap.values()].sort(byTitle),   'Practice Area',       filters.practice);
	populateSelect('filter-industry', [...ai.values()].sort(byTitle),   'Industry Experience', filters.industry);
	populateSelect('filter-school',   [...as_.values()].sort(byTitle),  'School',              filters.school);
	populateSelect('filter-position', [...apos.values()].sort(byTitle), 'Position',            filters.position);
}

function populateSelect(id, options, placeholder, selectedSlug) {
	const sel = document.getElementById(id);
	if (!sel) return;
	sel.innerHTML = `<option value="">${placeholder}</option>` +
		options.map(o => `<option value="${esc(o.slug)}"${o.slug === selectedSlug ? ' selected' : ''}>${esc(o.title)}</option>`).join('');
}

function renderAlpha(filters) {
	const withoutAlpha = applyFilters(allAttorneys, { ...filters, alpha: '' });
	const available = new Set(
		withoutAlpha.filter(a => a.lastName).map(a => a.lastName[0].toUpperCase())
	);
	document.querySelectorAll('#attorneys-alpha-links a').forEach(link => {
		const letter = link.textContent.trim();
		const has = available.has(letter);
		const isActive = filters.alpha === letter;
		link.className = [isActive ? 'is-active' : '', !has ? 'is-disabled' : ''].filter(Boolean).join(' ');
		link.setAttribute('aria-disabled', String(!has));
		link.tabIndex = has ? 0 : -1;
	});
}

function syncUrl(filters) {
	const p = new URLSearchParams();
	Object.entries(filters).forEach(([k, v]) => { if (v) p.set(k, v); });
	const qs = p.toString();
	history.pushState({}, '', window.location.pathname + (qs ? '?' + qs : ''));
}

function render() {
	const filtered = applyFilters(allAttorneys, activeFilters);
	renderGrid(filtered);
	renderDropdowns(filtered, activeFilters);
	renderAlpha(activeFilters);
}

function bindEvents() {
	['filter-practice', 'filter-industry', 'filter-school', 'filter-position'].forEach(id => {
		document.getElementById(id)?.addEventListener('change', e => {
			const key = id.replace('filter-', '');
			activeFilters = { ...activeFilters, alpha: '', [key]: e.target.value };
			render();
			syncUrl(activeFilters);
		});
	});

	document.getElementById('attorneys-alpha-links')?.addEventListener('click', e => {
		const link = e.target.closest('a');
		if (!link) return;
		e.preventDefault();
		if (link.classList.contains('is-disabled')) return;
		const letter = link.textContent.trim();
		activeFilters = { alpha: letter, name: '', practice: '', industry: '', school: '', position: '' };
		render();
		syncUrl(activeFilters);
	});

	document.querySelector('.attorneys-home-view-all')?.addEventListener('click', e => {
		e.preventDefault();
		activeFilters = { alpha: '', name: '', practice: '', industry: '', school: '', position: '' };
		render();
		syncUrl(activeFilters);
	});

	document.querySelector('.attorneys-home-filters')?.addEventListener('submit', e => {
		e.preventDefault();
		const nameVal = document.getElementById('attorney-name-search')?.value.trim() || '';
		activeFilters = { ...activeFilters, alpha: '', name: nameVal };
		render();
		syncUrl(activeFilters);
	});

	window.addEventListener('popstate', () => {
		activeFilters = readUrlState();
		render();
	});
}

document.addEventListener('DOMContentLoaded', () => {
	if (document.getElementById('attorneys-grid')) {
		init();
	}
});
